import styles from './index.module.css';
import MathoLogo from '../../assets/images/matho/matho_logo.png';

const PrivacyPolicy = () => (
    <main className={styles.page}>
        <article className={styles.policy}>
            <header className={styles.header}>
                <div className={styles.headerSec}>
                    <span className={styles.title}>Privacy Policy</span>
                    <img src={MathoLogo} alt="Matho Logo" className={styles.logo} />
                </div>
                <p className={styles.effectiveDate}>
                    <strong>Effective Date:</strong> 04/11/2026
                </p>
            </header>

            <section className={styles.section}>
                <h2>1. Introduction</h2>
                <p>
                    This Privacy Policy applies to Matho (&quot;App&quot;), provided by
                    Ardillalabs (Pvt) Ltd. We are committed to protecting your privacy
                    and transparently explaining how we collect, use, and share
                    information.
                </p>
            </section>

            <section className={styles.section}>
                <h2>2. Age Restriction</h2>
                <p>
                    The App is intended solely for users who are 18 years of age or
                    older. We do not knowingly collect personal information from
                    anyone under the age of 18. If we become aware that we have
                    collected data from a user under 18, we will take steps to delete
                    that information.
                </p>
            </section>

            <section className={styles.section}>
                <h2>3. Information We Collect</h2>
                <div className={styles.tableWrapper}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th scope="col">Data Category</th>
                                <th scope="col">Information Types</th>
                                <th scope="col">Primary Purpose</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row">Device Information</th>
                                <td>IP address, device model, OS version</td>
                                <td>
                                    Ensures core application functionality and
                                    compatibility.
                                </td>
                            </tr>
                            <tr>
                                <th scope="row">Advertising Data</th>
                                <td>Advertising IDs, ad interaction metrics</td>
                                <td>
                                    Serves relevant video ads to allow earning in-game
                                    lives and coins.
                                </td>
                            </tr>
                            <tr>
                                <th scope="row">Gameplay Data</th>
                                <td>Level progress, scores, achievement data</td>
                                <td>
                                    Improves overall user experience and application
                                    balancing.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            <section className={styles.section}>
                <h2>4. How We Use Your Information</h2>
                <ul>
                    <li>To provide, maintain, and improve the App.</li>
                    <li>To display rewarded video ads.</li>
                    <li>To monitor and analyze trends, usage, and activities.</li>
                </ul>
            </section>

            <section className={styles.section}>
                <h2>5. Third-Party Services</h2>
                <p>
                    Our app uses Google AdMob, a third-party advertising service provided by Google LLC, to display advertisements within the app.
                    <br />
                    Google AdMob may automatically collect and process certain information when you use our app to provide advertisements, measure advertising performance, prevent advertising fraud, and improve advertising services.
                </p>
                <p>The information collected may include:</p>
                <ul>
                    <li>Device information, such as device model, operating system, and device settings.</li>
                    <li>Advertising identifiers, such as the Android Advertising ID (AAID), where available.</li>
                    <li>IP address and approximate location information derived from it.</li>
                    <li>Information about your interactions with advertisements, including ad impressions and clicks.</li>
                    <li>App usage and diagnostic information relevant to advertising services.</li>
                </ul>
                <br />
                <p>Google may use this information to provide personalized or non-personalized advertisements, depending on your device settings, applicable consent requirements, and the advertising configuration used by our app.</p>
                <strong>Advertising Service Provider</strong>
                <p>Our advertising provider is:</p>
                <ul>
                    <li>Google AdMob: <a href="https://admob.google.com/" target="_blank" rel="noopener noreferrer">https://admob.google.com/</a></li>
                    <li>Google Privacy Policy: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a></li>
                    <li>How Google uses data when you use our partners&apos; apps or sites: <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer">https://policies.google.com/technologies/partner-sites</a></li>
                </ul>
                <p>Google processes information in accordance with its own privacy policies and applicable terms.</p>
                {/* <strong>Managing Your Advertising Preferences</strong>
                <p>You can manage your advertising preferences through your Android device settings:</p>
                <ul>
                    <li><strong>Reset Advertising ID:</strong> You can reset your device&apos;s Advertising ID through Settings → Privacy → Ads, where supported.</li>
                    <li><strong>Delete Advertising ID:</strong> On supported Android versions, you may delete your Advertising ID through Settings → Privacy → Ads.</li>
                </ul>
                <br />
                <p>You may still receive advertisements after resetting or deleting your Advertising ID. These advertisements may be less personalized.</p> */}
                <p>For users in regions where consent is required, such as the European Economic Area (EEA), the United Kingdom, and Switzerland, we will provide appropriate consent and advertising preference options where applicable.</p>
                <p>For more information about Google&apos;s advertising and privacy practices, please refer to Google&apos;s Privacy Policy.</p>
            </section>

            <section className={styles.section}>
                <h2>6. Data Sharing and Disclosure</h2>
                <p>
                    We do not sell your personal information to third parties. We may share your information with trusted third-party service providers (such as Google AdMob) strictly to operate our App and deliver services. We may also disclose information if required to do so by law or in response to valid requests by public authorities.
                </p>
            </section>

            {/* <section className={styles.section}>
                <h2>7. Data Retention</h2>
                <p>
                    We retain your gameplay and device data for as long as you have the App installed on your device or as needed to provide you with our services. If you uninstall the App, locally stored data will be deleted, though our third-party providers may retain advertising data according to their own retention policies.
                </p>
            </section> */}

            <section className={styles.section}>
                <h2>7. Data Security</h2>
                <p>
                    We implement commercially reasonable security measures to protect your information from unauthorized access, alteration, or destruction. However, please be aware that no method of electronic storage or transmission over the internet is 100% secure, and we cannot guarantee absolute data security.
                </p>
            </section>

            <section className={styles.section}>
                <h2>8. Your Data Rights</h2>
                <p>
                    Depending on your local privacy laws, you may have the right to access, correct, or request the deletion of your personal data. If you wish to exercise these rights or have questions about the data we hold, please contact us using the information provided below.
                </p>
            </section>

            <section className={styles.section}>
                <h2>9. Changes to This Policy</h2>
                <p>
                    We may update this Privacy Policy periodically to reflect changes in our practices or relevant laws. We will notify you of any material changes by updating the &quot;Effective Date&quot; at the top of this policy. We encourage you to review this page occasionally to stay informed.
                </p>
            </section>

            <section className={styles.section}>
                <h2>10. Contact Us</h2>
                <p>
                    If you have any questions about this Privacy Policy, please
                    contact us at:
                </p>
                <address className={styles.contact}>
                    <p>
                        <strong>Email:</strong>{' '}
                        <a href="mailto:kavishka@ardillalabs.com">
                            kavishka@ardillalabs.com
                        </a>
                    </p>
                </address>
            </section>
        </article>
    </main>
);

export default PrivacyPolicy;